(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name : dwt create PE service
   * @returns : rest calls to create PE detail, creating JSON request objects
   *          for service calls.
   * @description : Service to view detail.
   */
  angular.module('dwtCreatePEClaimModule').factory('CreateDwtPEReqService', [
    '$http',
    '$resource',
    function ($http, $resource) {
      return {
        createDwtPERequest: function (data) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: 'v1/dwtclaims',
            method: 'POST',
            data: data,
          });
        },
        searchSans: function (data) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url:
              'v1/dwtclaims/PE/' +
              data.intermediaryId +
              '/' +
              data.securityAccountNo +
              '/data',
            method: 'GET',
            data: data,
          });
        },
        editDWTPERequest: function (data, eventId, claimId) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: 'v1/dwtevents/' + eventId + '/dwtclaims/' + claimId,
            method: 'PUT',
            data: data,
          });
        },
        getPaymentRefrenceNumber: function (intermediaryId, eventId) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: 'v1/dwtclaims/' + intermediaryId + '/' + eventId + '/home',
            method: 'GET',
          });
        },
      };
    },
  ]);
})();
